import { TVerificationRequest } from "../models";

const getIndividualTitle = (
  data?: TVerificationRequest | null
): string | undefined => {
  if (
    data?.additionalItems?.userInformationParsed?.first_name &&
    data?.additionalItems?.userInformationParsed?.last_name
  ) {
    return `${data.additionalItems.userInformationParsed.first_name} ${data.additionalItems.userInformationParsed.last_name}`;
  }

  return undefined;
};

const getEntityTitle = (
  data?: TVerificationRequest | null
): string | undefined => {
  if (data?.additionalItems?.entityInformationParsed?.entity_name) {
    return data.additionalItems.entityInformationParsed.entity_name;
  }

  return undefined;
};

export const getTitle = (
  id: string,
  data?: TVerificationRequest | null
): string => {
  if (data?.category === "entity") {
    return getEntityTitle(data) ?? id;
  }

  return getIndividualTitle(data) ?? id;
};
